<template>
  <div>
    <label class="form-control-label">{{ label }}</label>
    <multiselect
      v-model="selectedProduct"
      :options="products"
      placeholder="Selecionar produto"
      label="name"
      :selected-label="'Selecionado'"
      :loading="loading"
      @search-change="debouncedGetProducts"
      @bottom-reached="getPreferredProducts"
      :multiple="multiple"
      track-by="id"
      :limit="1"
      :limit-text="limitText"
      :close-on-select="closeOnSelect"
      open-direction="bottom"
    >
      <template 
        v-if="multiple == true" 
        slot="beforeList"
      >
        <div 
          @click="toggleSelectAll" 
          :class="allSelected ? 'all-selected ' : 'multiple select-all-option'" 
          :style="allSelected ? 'background-color: #e9ecef; color: #212529' : ''"
        >
          <span 
            :style="allSelected ? 'font-weight: 700' : ''"
          >
            {{ allSelected ? 'desmarcar todos' : 'selecionar todos' }}
          </span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import axios from "@/backend/axios/index.js";

export default {
  name: 'PreferredProductMultiselect',
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: 'Produto',
    },
    filter: {
      type: [String, Object],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      products: [],
      loading: false,
      pagination: {
        page: 1,
        per_page: 20,
      },
      getProductTimeout: null,
      allSelectedActive: false,
      totalProducts: null,
      totalCounter: 0,
      lastProductQuery: null,
    };
  },
  mounted() {
    this.getPreferredProducts();
  },
  methods: {
    async getPreferredProducts(query) {
      this.loading = true;

      const requestParams = {
        name: query,
        page: this.pagination.page,
      }

      let q = null

      if (query && query.length > 0)  {
        q = {}
        q.name = query; 
      }

      if (q) requestParams.q = q;

      try {
        const response = await axios.get("/api/v1/preferredproducts", {
            params: requestParams,
      });
        const maxPage = response.data.pages;
      
        const initialProducts = response.data.preferredproducts || response.data.data || [];

        if (!this.totalProducts) this.totalProducts = response.data.count;
        
        if (this.pagination.page > maxPage) this.pagination.page--;

        if (this.pagination.page === 1) {
          this.products = initialProducts;

        if (this.allSelectedActive) this.selectedProduct = initialProducts;
        } else {
          const uniqueProduct = initialProducts.filter(newProduct => !this.products.some(product => product.id === newProduct.id));
          this.products = [...this.products, ...uniqueProduct];

          if (this.allSelectedActive) this.selectedProduct = [...new Set([...this.selectedProduct, ...initialProducts])];
        }

        if (this.pagination.page != maxPage) this.pagination.page++;


        this.lastProductQuery = query;
      } catch (error) {
        console.error('[PreferredProductMultiselect][getPreferredProducts]', error);
      } finally {
        this.loading = false;
      }
    },
    debouncedGetProducts(query) {
      this.pagination.page = 1
      if (this.getProductsTimeout) clearTimeout(this.getProductsTimeout);

      this.getProductsTimeout = setTimeout(
        () => this.getPreferredProducts(query),
        700
      );
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedProduct = [];
        this.allSelectedActive = false;
      } else {
        this.selectedProduct = [...this.products];
        this.allSelectedActive = true;
      }
    },
    limitText(count) { 
      if (this.allSelectedActive){
        this.totalCounter = this.totalProducts - this.deselectedFromAll.length - 1;
      } else {
        this.totalCounter = count;
      }
      return `+ ${this.totalCounter}`;
    },
    clear() {
      this.selectedProduct = []
    },
  },
  computed: {
    deselectedFromAll() {
      if (!this.allSelectedActive) return [];

      return this.products.filter(product => !this.selectedProduct.some(selectedProduct => selectedProduct.id == product.id));
    },
    allSelected() {
      if (this.allSelectedActive && !this.products.length) return true;

      return (
        this.products.length &&
        this.selectedProduct.length === this.products.length
      );
    },
    selectedProduct: {
      get() {
        return this.value;
      },
      set(value) {
        if (Array.isArray(value)) {
          console.log('[selectedProduct][value]', value);
          
          this.$emit('input', value);
        } else {
          const newValue = [...this.value];
          const itemIndex = newValue.findIndex(item => item.id === value.id);
          if (itemIndex !== -1) {
            newValue.splice(itemIndex, 1); 
          }
          else {
            console.log("Item not found for removal:");
          }
          console.log('[productMultiselect][newValue]', newValue);
          
          this.$emit('input', newValue);
        }
      }
    },
  }
};
</script>
<style scoped>
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>